import { render, staticRenderFns } from "./ContactLetter.vue?vue&type=template&id=5669e348"
import script from "./ContactLetter.vue?vue&type=script&lang=js"
export * from "./ContactLetter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports